window.Popper = require('popper.js').default;
global.$ = global.jQuery = require('jquery');

require('bootstrap');
require('parsleyjs');
require('./bootstrap-alerts');

import owlCarousel from 'owl.carousel';
import { initGiftVipModal } from './giftVipModal';

$(document).ready(function() {
    $('[data-toggle="tooltip"]').tooltip();

    initGiftVipModal();

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    let hasParsleyForm = $('.form');
    if (hasParsleyForm.length > 0) {
        hasParsleyForm.parsley({
            errorClass: 'is-invalid',
            successClass: 'is-valid',
            errorsWrapper: '<div class="invalid-feedback"></div>',
            errorTemplate: '<span></span>',
            trigger: 'change'
        });
    }

    let carousel = $('.camera-carousel');
    if (carousel.length > 0) {
        carousel.on({
            'initialized.owl.carousel': function () {
                carousel.find('.item').show();
                carousel.find('.loading-placeholder').hide();
            }
        }).owlCarousel({
            loop: true,
            margin: 10,
            nav: false,
            items: 4,
            autoplay: true,
            autoplaySpeed: 2500,
            autoplayTimeout: 2500,
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 3
                },
                1000: {
                    items: 4
                }
            }
        });
    }

    /**
     * Smooth scroll for articles
     */
    $('.read-more').on('click', function(e) {
        e.preventDefault();

        $('body,html').animate({
            scrollTop: $(this.hash).offset().top
        }, 1000 );
    });
});